import {Theme} from '../types';

export const defaultTheme: Theme = {
    id: 'defaultTheme',
    name: 'Dark',
    color: {
        'primary': '#111118',
        'secondary': '#000000',
        'card': '#2A292F',
        'secondary-control': '#A5AEBD',
        'icon': '#F4F5F8',
        'text': '#F4F5F8',
        'text-pill': '#F4F5F8',
        'text-caption': 'rgba(244, 245, 248, 0.8)',
        'border': 'rgba(255, 255, 255, 0.1)',
        'hover': 'rgba(244, 245, 248, 0.12)',
        'app-icon-background': '#3A373D',
        'accent': '#7B7BFF',
        'positive': '#29AF6F',
        'caution': '#D2B617',
        'negative': '#F55D5F'
    }
};
